import KunLoading106 from './src/index'

KunLoading106.install = function (Vue) {
	Vue.component(KunLoading106.name, KunLoading106);
}

export default KunLoading106;
